
import { compose, mdsWidget } from 'dojo/_base/declare';
import WidgetNavigationMap from "../../moreCore/UI/Navigation/WidgetNavigationMap";
import DigitalSignatureFileFinder from "./DigitalSignatureFileFinder/DigitalSignatureFileFinder";



enum NavigationGroups {

}
enum FeaturePaths {

}

interface recordWithClassnames {

}
class DigitalSignatureNavigation extends compose(WidgetNavigationMap<{}>) {

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setup({
            "FileFinder": {
                navigationAreaName: "DigitalSignature__Navigation_FileFinder",
                icon: "fas fa-file",
                label: "DigitalSignature__FileFinder_MainTitle",
                colorClass: "w3-yellow",
                roles: ["DigitalSignature_Files"],
                featurepath: "DigitalSignature/Files",
                targetWidget: DigitalSignatureFileFinder
            }
        });
    }

}

export default mdsWidget(DigitalSignatureNavigation);